var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFinalizingIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#4B3913"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9187_23171)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 4.75C8.96165 4.75 7.94662 5.05791 7.08326 5.63478C6.2199 6.21166 5.54699 7.0316 5.14963 7.99091C4.75227 8.95022 4.64831 10.0058 4.85088 11.0242C5.05345 12.0426 5.55347 12.9781 6.28769 13.7123C7.02192 14.4465 7.95738 14.9466 8.97578 15.1491C9.99418 15.3517 11.0498 15.2477 12.0091 14.8504C12.9684 14.453 13.7883 13.7801 14.3652 12.9167C14.9421 12.0534 15.25 11.0384 15.25 10C15.2484 8.6081 14.6948 7.27367 13.7106 6.28944C12.7263 5.30522 11.3919 4.75159 10 4.75ZM10 14.5C8.80653 14.5 7.66194 14.0259 6.81802 13.182C5.97411 12.3381 5.5 11.1935 5.5 10C5.5 8.80653 5.97411 7.66193 6.81802 6.81802C7.66194 5.97411 8.80653 5.5 10 5.5V10L13.1804 13.1804C12.7633 13.599 12.2677 13.9311 11.7219 14.1576C11.1761 14.384 10.5909 14.5004 10 14.5Z",
    fill: "#FABD40"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9187_23171"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinalizingIcon);
export default __webpack_public_path__ + "static/media/finalizingIcon.91241c4331d50163152358431e6cecc9.svg";
export { ForwardRef as ReactComponent };